import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { BuyerCardComponent } from './buyer-card/buyer-card.component';
import { InformationDocumentationComponent } from './information-documentation/information-documentation-page.component';
import { LocateMapComponent } from './locate-map/locate-map.component';
import { EligibilityCheckComponent } from './locate-property-page/eligibility-check/eligibility-check.component';
import { IneligibleNoticeComponent } from './locate-property-page/ineligible-notice/ineligible-notice.component';
import { LocatePropertyPageComponent } from './locate-property-page/locate-property-page.component';
import { SelectParcelsComponent } from './locate-property-page/select-parcels/select-parcels.component';
import { NewSitePageComponent } from './new-site-page/new-site-page.component';
import { NewSiteStepThreeComponent } from './new-site-step-three/new-site-step-three.component';
import { NewSiteStepTwoComponent } from './new-site-step-two/new-site-step-two.component';
import { ParcelInfoComponent } from './parcel-info/parcel-info.component';
import { SelectOfferComponent } from './select-offer/select-offer.component';
import { SiteRoutingModule } from './site-routing.module';
import { EligibilityQuestionsComponent } from './submit-site/eligibility-questions/eligibility-questions.component';
import { SubmitSiteComponent } from './submit-site/submit-site-page/submit-site-page.component';

import { SharedModule } from '../../shared';

@NgModule({
  declarations: [
    LocatePropertyPageComponent,
    LocateMapComponent,
    NewSitePageComponent,
    ParcelInfoComponent,
    EligibilityCheckComponent,
    SelectParcelsComponent,
    IneligibleNoticeComponent,
    NewSiteStepTwoComponent,
    NewSiteStepThreeComponent,
    SubmitSiteComponent,
    InformationDocumentationComponent,
    EligibilityQuestionsComponent,
    SelectOfferComponent,
    BuyerCardComponent,
  ],
  imports: [CommonModule, SharedModule, ReactiveFormsModule, SiteRoutingModule],
})
export class SiteModule {}
